import $ from 'jquery'
// import "../assets/global/scripts/dropdown"

export default {
  inserted(el) {
    const $el = $(el)
    const type = $el.attr('type')
    const $wrap = $('<div></div>')
    const $inne = $('<span></span>')

    if (type === 'checkbox') {
      $wrap.addClass('checker')
    } else if (type === 'radio') {
      $wrap.addClass('radio')
    } else {
      return
    }

    $wrap.append($inne)
    $el.after($wrap)
    $inne.append($el)

    $el.on('change', function() {
      if ($(this).prop('checked')) {
        $inne.addClass('checked')
      } else {
        $inne.removeClass('checked')
      }
    })
  },
  update() {}
}
